import React, { useContext, useState } from "react";

type GlobalModal = JSX.Element | null | undefined;
// @ts-ignore
const GlobalModalContext = React.createContext<{
  globalModal: GlobalModal;
  setGlobalModal: React.Dispatch<React.SetStateAction<GlobalModal>>;
}>();

/**
 * A context that adds a global modal that is inserted into Home.jsx and can display any content
 * @returns JSX
 */
export function GlobalModalProvider({ children }: any) {
  const [globalModal, setGlobalModal] = useState<GlobalModal>();

  return (
    <GlobalModalContext.Provider
      value={{
        globalModal,
        setGlobalModal,
      }}
    >
      {children}
    </GlobalModalContext.Provider>
  );
}

export { GlobalModalContext };
